import React from 'react';
import { InventoryEntities } from 'client/data/models/inventory';
import { WARRANTY_TYPE } from 'site-modules/shared/constants/inventory/warranty';

const getEdmundsExplanationForType = warrantyType => {
  const warrantyExplanationMap = {
    [WARRANTY_TYPE.EV_BATTERY]:
      'The federal government requires that EV batteries be warrantied for a minimum of 8 years or 100,000 miles. The EV battery warranty includes replacement if your battery capacity drops below a certain percentage (usually 70%) of the original capacity.',
    [WARRANTY_TYPE.BASIC]:
      'A basic or "bumper-to-bumper" warranty covers everything except parts that are expected to need replacement from normal wear and tear, such as oil filters and wiper blades. This type of warranty will not cover tires and batteries, and will not cover any damage that is due to misuse of the car.',
    [WARRANTY_TYPE.DRIVETRAIN]:
      "The drivetrain warranty takes care of most of the parts that make the car move, such as internal engine components, axles and the transmission. Like a basic warranty, the drivetrain warranty typically doesn't cover parts that are subject to normal wear and tear, including hoses and belts. ",
    [WARRANTY_TYPE.RUST]:
      'A rust warranty protects you from corrosion problems with a vehicle\'s exterior metal panels. The corrosion usually has to be so severe that there is perforation or "rust-through" in the affected area, meaning a visible hole. Surface rust likely won\'t be covered.',
    [WARRANTY_TYPE.ROADSIDE]:
      "Most manufacturers provide a service that will rescue you if your car leaves you stranded. You're covered if you lock yourself out of the car, get a flat tire, battery dies, run out of gas, etc. See your owner's manual or ask your dealer for details.",
    [WARRANTY_TYPE.HYBRID_COMPONENT]:
      'Hybrid batteries are federally mandated to carry at least 8 years or 100,000 miles of warranty coverage from the manufacturer. Batteries that lose capacity more rapidly than expected should be eligible for replacement under warranty. Coverage of additional hybrid components beyond the battery itself will vary by automaker.',
    [WARRANTY_TYPE.FREE_COMPLIMENTARY_MAINTENANCE]:
      "Free maintenance programs cover scheduled maintenance during the early years of a car's life, typically including items like oil changes, filters and spark plugs.",
  };

  return warrantyExplanationMap[warrantyType] || '';
};

export function WarrantyComments(props) {
  const {
    warrantyItem: { comments, warrantyType },
  } = props;

  return (
    <div className="text-cool-gray-40">
      {!!comments && (
        <p>
          <strong>Manufacturer comments: </strong>
          {comments}
        </p>
      )}
      <p className="mb-0">
        <strong>Edmunds explanation: </strong>
        {getEdmundsExplanationForType(warrantyType)}
      </p>
    </div>
  );
}

WarrantyComments.propTypes = {
  warrantyItem: InventoryEntities.WarrantyItem.isRequired,
};
